// extracted by mini-css-extract-plugin
module.exports = {"profileImage":"Avatar_profileImage__2b-Sq","clicked":"Avatar_clicked__2SZUr"};